export default {"src":"/_next/static/media/baikal.7c5c366c.svg","height":20,"width":108,"blurWidth":0,"blurHeight":0};